module.exports = __webpack_public_path__ + "static/media/logo4.2fe79f37.png";